/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewticketearningshint3Inputs */

const en_overviewticketearningshint3 = /** @type {(inputs: Overviewticketearningshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your earnings after fees`)
};

const de_overviewticketearningshint3 = /** @type {(inputs: Overviewticketearningshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Einnahmen nach Gebühren`)
};

/**
* | output |
* | --- |
* | "Your earnings after fees" |
*
* @param {Overviewticketearningshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewticketearningshint3 = /** @type {((inputs?: Overviewticketearningshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewticketearningshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewticketearningshint3(inputs)
	return de_overviewticketearningshint3(inputs)
});
export { overviewticketearningshint3 as "overviewTicketEarningsHint" }